import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { useSelector } from 'react-redux'
import { FilterProvider } from '../../../ui/contexts/FilterContext'
import { selectHasTitles, selectHasCategories } from '../../../../flux/selectors/ux'
import SearchFilter from '../SearchFilter'
import CategoriesFilter from '../CategoriesFilter'
import CategoriesFilterCta from '../CategoriesFilterCta'
import CategoryListScroller from '../CategoryListScroller'
import LoadingSkeleton from '../../Generics/LoadingSkeleton/index'

const StyledFilterBar = styled.div(() => ({
  alignItems: 'center',
  display: 'flex',
  paddingBottom: '5px',
}))

const FiltersProducts = ({
  mainRef,
}) => {
  const hasCategories = useSelector(selectHasCategories)
  const hasTitles = useSelector(selectHasTitles)

  return hasCategories !== undefined ? (
    <FilterProvider>
      <StyledFilterBar>
        {hasTitles || hasCategories ? <SearchFilter mainRef={mainRef} /> : null}
        {hasCategories ? <CategoriesFilterCta /> : null}
      </StyledFilterBar>
      { hasCategories ? (
        <StyledFilterBar>
          <CategoriesFilter />
          <CategoryListScroller />
        </StyledFilterBar>
      ) : null}
    </FilterProvider>
  ) : <LoadingSkeleton margin="0px 0px 20px 0px" height="45px" />
}

FiltersProducts.propTypes = {
  mainRef: PropTypes.shape({}),
}

FiltersProducts.defaultProps = {
  mainRef: {},
}

FiltersProducts.displayName = 'FiltersProducts'
FiltersProducts.whyDidYouRender = true

export default React.memo(FiltersProducts)
